import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider.js'
import FinanceGroupsDt from '@/services/dataTransferModules/financeGroupsDt'

export default function useFinanceGroups(params = {}) {
	const financeGroupsDt = new FinanceGroupsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingFinanceGroup: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: financeGroups,
		getEntities: getFinanceGroups,

		entity: financeGroup,
		getEntity: getFinanceGroup,

		entityPreview: financeGroupPreview,
		getEntityPreview: getFinanceGroupPreview,

		entityPopup: financeGroupPopup,
		getEntityPopup: getFinanceGroupPopup,

		createEntity: createFinanceGroup,

		patchEntity: putFinanceGroup,
		updateEntity: updateFinanceGroup,

		deleteEntity: deleteFinanceGroup
	} = useBlProviders(
		financeGroupsDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Finance groups loaded with an error'),

			showErrorNotificationForCreatingEntity: true,
			errorNotificationTextForCreatingEntity: $t('Error when adding finance group'),

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Error when editing a finance group'),

			showErrorNotificationForDeletingEntity: true,
		}, params))

	return {
		flags,
		financeGroups,
		financeGroupPreview,
		financeGroupPopup,
		financeGroup,
		defaults,
		getFinanceGroups,
		getFinanceGroupPreview,
		getFinanceGroupPopup,
		getFinanceGroup,
		createFinanceGroup,
		deleteFinanceGroup,
		updateFinanceGroup,
		putFinanceGroup,
	}
}
